<template>

  <!--span style="cursor:pointer;" @click="openModal()" >{{ PointView.id }}</span-->

  <div class="modal fade" tabindex="-1" :id="'Modal' + TbtnId"  v-if="active">
          <div class="modal-dialog modal-lg" >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="editModalLabel"> 학습점수관리</h5>
  </div>

  <div class="modal-body">
    <table class="table">
      <tbody>
        <tr>
          <th>선택회원</th>
          <td style="text-align:center;">
            <input 
                  type="text"
                  class="hidtype"                   
                  v-model="chData.name" 
                  readonly        
                />         
                <input type="hidden" v-model="chData.id" />   
          </td>
          <th>유형</th>
          <td colspan="3" style="text-align:center;" >
              <select class="hidtype" v-model="Psub.chrGubun">
              <option value="P" selected>적립</option>
              <option value="M">차감</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>종류</th>
          <td style="text-align:center;">
              <select class="hidtype" v-model="Psub.chrPType" >
              <option value="" selected>선택</option>
              <option value="A">ALPHA</option>
              <option value="C">CARAT</option>
              <option value="F">FAME</option>                
            </select>
          </td>
          <th style="width:13%">점수</th>
          <td style="text-align:center;width:10%;padding-left: 10px;">            
              <select class="hidtype" @input="doChange('intPoint', $event.target.value)" v-model="Psub.setPoint" >
              <option value="" selected>선택</option>
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="300">300</option>
              <option value="400">400</option>
              <option value="500">500</option>
              <option value="1000">1000</option>
              <option value="2000">2000</option>
              <option value="3000">3000</option>
              <option value="5000">5000</option>
              <option value="self">직접입력</option>
             </select>
           </td>
           <td style="text-align:center;width:18%">       
             <input type="number" class="form-control" style='width:70%;margin-left:20px'  v-model="Psub.intPoint" id = "intPoint" readonly @input="inputNumber($event)"
             oninput="this.value = this.value.replace(/[^0-9.]/g, '')" >
            
          </td>
        </tr>
        <tr>
          <th>내용</th>
          <td colspan="5" style="text-align:center;">
            <input type="text" class="form-control" style='width:95%;margin-left:20px' placeholder="여기에 내용을 작성 .." maxlength = "20"
            v-model="Psub.strHistory" />
          </td>            
        </tr>          
      </tbody>
    </table>
    <div style="text-align:left; font-size:14px; line-height:10px; margin:0px; padding:10px 20px; " >
      <p style="color:red">[관리 안내]</p>
       <p>- 선택된 모든 회원에게 일괄 처리되므로 관리할 내용과 회원이 정확한지 꼭 확인해 주세요!</p> 
          </div>
<div class="flex_center">     
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"> 닫기</button>
    <button type="button" class="btn btn-danger" @click="addPoint()">등록</button>
  </div>
  </div></div>
</div>
</div>
</template>

<script>
import axios from 'axios'
export default {
    "name": "PointView",
    components: {

    },
    methods: {
      nvl(str, altStr){
        if(typeof str == "undefined" || str == null) str = altStr ;
         return str ;

      },
      openModal() {
        this.active = true;
       // console.log(this.Psub.username);
       this.Psub = {
        "chrGubun": "P",
        "chrPType": "",
        "intPoint": "",
        "strHistory": ""                
       }
        this.$nextTick(function(){
          var modalDom = document.getElementById("Modal" + this.TbtnId);
          var modal = (bootstrap.Modal.getOrCreateInstance(modalDom));
          modalDom.addEventListener('hidden.bs#Modal', function (event) {
            this.active = false;
          })
          //console.log(modalDom);
          modal.show();

        });
      },
     
      doChange(name, value) {
        if (value == "self") {          
          this.Psub.setPoint = "self";
          this.Psub.intPoint = "";
          document.getElementById("intPoint").readOnly  = false;          
        } else {
          this.Psub.setPoint = value;
          this.Psub.intPoint = value;
          document.getElementById("intPoint").readOnly  = true;     
        }
      },
       doSend() {
        // 업데이트일 경우 patch /businesses/번호
        // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
        var data = this.changedData;
       // console.log("data"+data);
       // return;
        var send = {
          method: this.creating ? "post" : "patch",
          url: '/students/point' + "/" + this.Psub.intNo,
          data: data
        };

       

            if(!this.active){
                //if(!confirm("아무 기관도 선택하지 않았습니다. 이 관리아이디는 로그인 할 수 없게 됩니다. 의도한 동작이 맞을 경우에만 확인을 누르세요.")) return;
                $.notify({
                  // options
                  message: '사용유무를 지정하셔야 합니다. '
                }, {
                  // settings
                  type: 'danger',
                  z_index: 9999
                });
                return;
            }

          if(Object.keys(this.changedData).length){

          axios(send).then((response) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '처리할 수 없습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              $.notify({
                // options
                message: '처리되었습니다'
              }, {
                // settings
                type: 'success',
                z_index: 9999
              });
              //this.$refs.qg.search()
              this.$parent.search();
              (bootstrap.Modal.getInstance(document.getElementById('Modal' + this.TbtnId))).hide();
            }


          })

          }


      },

  addPoint() {
  
  if(this.Psub.chrPType==""){
    alert('종류를 선택해주세요.');   
    return;
  }
  if(this.Psub.intPoint==""){
    alert('점수를 입력해주세요.');   
    return;
  }
  var data = {
    chrGubun: this.Psub.chrGubun,
    chrPType: this.Psub.chrPType,
    intPoint: this.Psub.intPoint,
    strHistory: this.Psub.strHistory,
    intMemberID: this.chData.id,
  };
  //console.log(data);
  var send = axios({
    method: this.creating ? "post" : "patch",
    url:
       "/students/pointIn" +      
      (!this.creating ? "/" + this.$route.params.article : ""),
    data: data,
  });
  send.then((response) => {
    if (response.data.error) {
      $.notify(
        {
          // options
          message: "처리할 수 없습니다 " + response.data.error,
        },
        {
          // settings
          type: "danger",
          z_index: 9999,
        }
      );
    } else {
      $.notify(
        {
          // options
          message: "처리되었습니다",
         
        },
        {
          // settings
          type: "success",
          z_index: 9999,
        }
      );

      // this.$router.push(
      //   this.creating
      //     ? response.data.id.toString()
      //     : "../" + response.data.id.toString()
      // );
      this.$parent.search();
      (bootstrap.Modal.getInstance(document.getElementById('Modal' + this.TbtnId))).hide();

    }
  });
},

inputNumber(event){
      this.result = event.target.value
    }

    },
        mounted() {
      this.chData = this.PointView;
      //console.log(this.Psub.bookclubs);
    },
    watch: {
      sub(){
        alert('Psub has been updated')
              this.chData = this.PointView;
      }
    },
    props: {
      PointView: {
        type: Object,
        default: {}
      },
      btnId: String
    },
    data(){
        return {
            TbtnId: this.btnId || Math.random().toString().substr(2, 5),
            creating:true,
            active: false,           
            Psub:{
            "chrGubun": "P",
            "chrPType": "",
            "setPoint": "",
            "intPoint": "",
            "strHistory": ""                
            },
            
            changedData: {
              
            },
            product: null,
            disable_init_search: true
        }
    }
}
</script>

<style>

</style>
